import { render, staticRenderFns } from "./ClinicianRegistration.vue?vue&type=template&id=57c4578c&"
import script from "./ClinicianRegistration.vue?vue&type=script&lang=js&"
export * from "./ClinicianRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports